module.exports = {
	"disputes": {
		"updated_success": "Dispute is successfully updated",
		"id": "ID",
		"status": {
			"title": "Status",
			"pending": "Pending",
			"in_progress": "In progress",
			"won": "Won",
			"lost": "Lost",
			"canceled": "Canceled"
		},
		"external_id": "External ID",
		"type": {
			"title": "Type",
			"normal": "Normal",
			"potential": "Potential"
		},
		"player_id": "Player ID",
		"transaction_date": "Transaction date",
		"chargeback_date": "Chargeback date",
		"order_guid": "Order GUID",
		"payment_id": "Payment ID",
		"provider": "Provider",
		"method": "Method",
		"category": "Category",
		"reason": "Reason",
		"deadline": "Deadline",
		"card_number": "Card number",
		"amount": "Amount",
		"external_status": "External status",
		"external_category": "External category",
		"actions": "Actions"
	}
};